'use client'

import { FormEvent, useContext, useEffect, useRef, useState } from "react";
import FloatDialog from "./_floatDialog";
import { SignContext } from "@/context/signContext";
import InqueryFooter from "../etc/inqueryFooter";
import customAlert from "@/util/customAlert";
import api from "@/util/api";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import getCookie from "@/util/getCookie";
import { useTranslations } from "next-intl";

interface duplicateCheckedTypes {
    username: boolean
    nickname: boolean
}
const duplicateCheckedDefault = {
    username: false,
    nickname: false
}

export default function FloatSignUp() {
    const { signUpShow, SetSignUpShow } = useContext(SignContext)
    const [username, setUsername] = useState<string>("")
    const [nickname, setNickname] = useState<string>("")
    const [nicknameEdit, setNicknameEdit] = useState<boolean>(false)
    const [full_name, set_full_name] = useState<string>("")
    const [phone_number, set_phone_number] = useState<string>("")
    const [duplicateChecked, setDuplicateChecked] = useState<duplicateCheckedTypes>(duplicateCheckedDefault)
    const [checkedItems, setCheckedItems] = useState({
        all: false,
        option1: false,
        option2: false,
    });
    const [nicknameAutoSet, setNicknameAutoSet] = useState<boolean>(false)
    const nicknameRef = useRef<HTMLInputElement>(null)

    const [error, setError] = useState<{ [key: string]: string }>({})

    const formRef = useRef<HTMLFormElement>(null)

    const t = useTranslations("Text")
    const a = useTranslations("Sentence")

    function RecomendCheck(){
        // 추천인 확인하는 API
        api('/recomender/')
            .then(res=> res.json())
            .then(({message, status_code})=> {
                if(status_code == 200){
                    customAlert(message, "success")
                }
            })
            .catch((error: Response)=> {
                console.log(error)
            })
    }

    function DuplicateCheck(checked: 'username' | 'nickname') {
        const formData = new FormData();
        if (checked == 'username') {
            if (!username) {
                customAlert(a("Invalid_Username"), 'warning')
                return;
            }
            formData.set('username', username)
        } else if (checked == 'nickname') {
            if (!nickname) {
                customAlert(a("Invalid_Nickname"), 'warning')
                return;
            }
            formData.set('nickname', nickname)
        }
        // const formBody = JSON.stringify(formData)
        const apiUrl = `/api/user/register/duplicate/`
        api(apiUrl, { method: 'post', body: formData, })
            .then(res => res.json())
            .then((data) => {
                customAlert(data.message, data.status)
                if (data.status == 'success') {
                    if (checked == 'username') {
                        setError({ username: "" })
                        setDuplicateChecked(prev => ({ ...prev, username: true }))
                    } else if (checked == 'nickname') {
                        setError({ nickname: "" })
                        setDuplicateChecked(prev => ({ ...prev, nickname: true }))
                    }
                } else {
                    if (checked == 'username') {
                        setError({ username: a("NicknameAlreadyUsed") })
                    } else if (checked == 'nickname') {
                        setError({ nickname: a("UsernameAlreadyUsed") })
                    }
                }
            })
            .catch((error: Response) => {
                console.error(error)
            })
    }

    function handleSignUpSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault();

        const formData = new FormData(e.currentTarget)
        const form_username = formData.get('username')
        const form_password = formData.get('password')
        const form_password2 = formData.get('password2')
        const form_nickname = formData.get('nickname')
        const form_code = formData.get('code')
        // const form_full_name = formData.get('full_name')
        // const form_phone_number = formData.get('phone_number')
        // const form_auth_number = formData.get('auth_number')

        if (!form_username) {
            setError({ username: a("Invalid_Username") })
            return;
        } else if (form_username) {

        }
        if (form_password != form_password2) {
            setError({ password2: a("PasswordMismatch") })
            return;
        }
        // if(!form_full_name){
        //     setError({full_name: "이름을 입력해주세요."})
        //     return;
        // }
        if (!form_nickname) {
            setError({ nickname: a("Invalid_Nickname") })
            return;
        }
        // if(!form_phone_number){
        //     setError({phone_number: "전화번호를 입력해주세요."})
        //     return;
        // }
        // if(!form_auth_number){
        //     setError({auth_number: "인증번호를 입력해주세요."})
        //     return;
        // }

        // if (!checkedItems.option1 || !checkedItems.option2) {
        //     customAlert('필수 동의 체크를 하셔야 합니다.', 'warning');
        //     return;
        // }
        if (!duplicateChecked.username) {
            setError({ username: a("CheckUsernameDuplicate") })
            customAlert(a("CheckUsernameDuplicate"), 'warning');
            return;
        }
        if (!duplicateChecked.nickname) {
            setError({ nickname: a("CheckNicknameDuplicate") })
            customAlert(a("CheckNicknameDuplicate"), 'warning');
            return;
        }
        setError({})

        api('/api/user/register/',
            { method: "POST", body: formData })
            .then(res => res.json())
            .then(({ message, status_code }) => {
                if (status_code == 200) {
                    customAlert(a("CompletedSignin"), 'success', () => {
                        SetSignUpShow(false)
                    })

                } else {
                    customAlert(message, 'error')
                }
            })
            .catch(() => {
                customAlert(a("ErrorRequest"), 'error')
            })
    }

    function SMS() {
        const fromData = new FormData()
        if (!full_name) {
            customAlert(a("Invalid_Name"), 'warning')
            return;
        }
        if (!phone_number) {
            customAlert(a("Invalid_PhoneNumber"), 'warning')
            return;
        }
        fromData.set(`name`, full_name)
        fromData.set(`phone_number`, phone_number)
        api(`/api/sms/send/`, { method: "POST", body: fromData })
            .then(res => res.json())
            .then((data) => {
                // console.log(data)
            })
    }

    function removeNicknameAutoSet(){
        const input = document.querySelector<HTMLInputElement>('input[name="nickname"]');
        if (input) {
            input.value = "";
            setNickname("")
            setDuplicateChecked(prev => ({ ...prev, nickname: false }))
            setNicknameEdit(true)
            setNicknameAutoSet(false)
            input.readOnly = false;
            input.focus()
        }
    }

    function autoNickname() {
        api(`/api/user/register/generate_nickname/`)
            .then(res => res.json())
            .then(({ status, data }) => {
                if (status == 'success') {
                    setNicknameAutoSet(true)
                    setNicknameEdit(false)
                    setNickname(data.nickname)
                    setDuplicateChecked(prev => ({ ...prev, nickname: true }))
                }
            })
    }

    useEffect(() => {
        if (signUpShow)
            autoNickname();
        else
            setDuplicateChecked({username: false, nickname: false})
    }, [signUpShow])

    const [getCode, setGetCode] = useState<string>("")
    useEffect(()=> {
        if(signUpShow){
            const getCookieCode = getCookie('code')
            if(getCookieCode){
                setGetCode(getCookieCode)
            }
        }else{
            setGetCode("")
        }
    }, [signUpShow])

    return (
        <FloatDialog
            show={signUpShow}
            setShow={SetSignUpShow}
            onHide={() => { setError({}) }}
            className="sign-up"
        >
            <FloatDialog.Head>{t("회원가입")}</FloatDialog.Head>
            <FloatDialog.Body>
                <form ref={formRef} onSubmit={handleSignUpSubmit}>
                    <div className="signup-container">
                        <div className="form-body">
                            <div className="form-row">
                                <p>{t("아이디 입력")} {error?.username && <span>{error.username}</span>}</p>
                                <div className="with-same">
                                    <input type="text" name="username" placeholder={a("usernameRule")} autoFocus
                                        className={duplicateChecked.username ? "checked" : ""}
                                        onChange={e => {
                                            if (e.currentTarget.value != username) {
                                                setDuplicateChecked(prev => ({ ...prev, username: false }))
                                            }
                                            setUsername(e.currentTarget.value)
                                        }
                                        } />
                                        {
                                            duplicateChecked.username 
                                            ? <div className="btn same checked"><FontAwesomeIcon icon={faCheck} /></div>
                                            : <div className="btn same" onClick={e => DuplicateCheck('username')}>{t("중복확인")}</div>
                                        }
                                </div>
                            </div>
                            <div className="form-row">
                                <p>{t("비밀번호 입력")} {error?.password && <span>{error.password}</span>}</p>
                                <input type="password" name="password" placeholder={a("passwordRule")} />
                            </div>
                            <div className="form-row">
                                <p>{t("비밀번호 확인")} {error?.password2 && <span>{error.password2}</span>}</p>
                                <input type="password" name="password2" placeholder={a("confirmPassword")} />
                            </div>
                            <div className="form-row">
                                <p>{t("닉네임 입력")} {error?.nickname && <span>{error.nickname}</span>}</p>
                                <div className="with-same">
                                    <input type="text" name="nickname" placeholder={a("nicknameRule")}
                                            className={duplicateChecked.nickname ? "checked" : ""}
                                            value={nickname}
                                            readOnly={nicknameAutoSet ? true : false}
                                            ref={nicknameRef}
                                            onFocus={e => {
                                                // if(!nicknameEdit){
                                                //     setNickname("")
                                                //     setNicknameEdit(true)
                                                //     setDuplicateChecked(prev => ({ ...prev, nickname: false }))
                                                // }
                                                
                                            }}
                                            onClick={(e)=>{
                                                if(!nicknameAutoSet)  e.currentTarget.readOnly = false;
                                            }}
                                            onChange={e => {
                                                if (e.currentTarget.value != nickname) {
                                                    setDuplicateChecked(prev => ({ ...prev, nickname: false }))
                                                }
                                                setNickname(e.currentTarget.value)
                                            }} />                                
                                        {
                                            nicknameAutoSet ? (
                                                <div className="btn same" onClick={e => removeNicknameAutoSet()}>{t("직접입력")}</div>
                                            ) : 
                                                duplicateChecked.nickname 
                                                    ? <div className="btn same checked"><FontAwesomeIcon icon={faCheck} /></div>
                                                    : <div className="btn same" onClick={e => DuplicateCheck('nickname')}>{t("중복확인")}</div>
                                                
                                        }
                                </div>
                                <div className={`small_notice`}>{a("nicknameOptional")}</div>
                            </div>
                            <div className="form-row m-t-20">
                                <p>{t("추천인")} {error?.code && <span>{error.code}</span>}</p>
                                {
                                    getCode
                                    ? <input type="text" name="code" placeholder={a("enterReferralOptional")} defaultValue={getCode && getCode} readOnly />
                                    : <input type="text" name="code" placeholder={a("enterReferralOptional")} />
                                }                                
                            </div>
                            
                            {/* <div className="form-row">
                                <p>이름 입력 {error?.full_name && <span>{error.full_name}</span>}</p>
                                <input type="text" 
                                       name="full_name" 
                                       placeholder="이름입력" 
                                       onChange={e=> set_full_name(e.currentTarget.value)}/>
                            </div> */}
                            {/* <div className="form-row">
                                <p>전화번호 입력 {error?.phone_number && <span>{error.phone_number}</span>}</p>
                                <input type="text" 
                                        name="phone_number" 
                                        placeholder={`"-" 없이 숫자만 입력`} 
                                        onChange={e=> set_phone_number(e.currentTarget.value)}/> */}
                            {/* <div className="with-same">
                                    <input type="text" 
                                           name="phone_number" 
                                           placeholder={`"-" 없이 숫자만 입력`} 
                                           onChange={e=> set_phone_number(e.currentTarget.value)}/>
                                    <div className="btn same" onClick={SMS}>인증번호 받기</div>
                                </div> */}
                            {/* </div> */}
                            {/* <div className="form-row">
                                <p>인증번호 입력 {error?.auth_number && <span>{error.auth_number}</span>}</p>
                                <div className="with-same">
                                    <input type="text" name="auth_number" placeholder="인증번호를 입력해주세요" />
                                    <div className="btn same">인증번호 확인</div>
                                </div>
                            </div> */}
                        </div>

                        {/* <p>※ 본인 명의의 휴대폰이 아니면 이벤트 참여할 수 없습니다.</p> */}

                        {/* <SignUpChecked checkedItems={checkedItems} setCheckedItems={setCheckedItems} /> */}

                        <div className="btns">
                            <button type="submit">{t("회원가입")}</button>
                        </div>
                        <InqueryFooter />
                    </div>
                </form>
            </FloatDialog.Body>
        </FloatDialog>
    )
}

interface checkedType {
    all: boolean
    option1: boolean
    option2: boolean
}
function SignUpChecked({ checkedItems, setCheckedItems }: {
    checkedItems: checkedType
    setCheckedItems: Function
}) {
    const a = useTranslations("Sentence")

    const checkedHandler = (name: string) => {
        if (name === 'all') {
            const newChecked = !checkedItems.all;
            setCheckedItems({
                all: newChecked,
                option1: newChecked,
                option2: newChecked,
            });
        } else {
            const newChecked = !checkedItems[name as 'option1' | 'option2'];
            const updated = {
                ...checkedItems,
                [name]: newChecked,
            };

            // all 체크 여부 동기화
            updated.all = updated.option1 && updated.option2;

            setCheckedItems(updated);
        }
    };

    return (
        <div className="signup-checked">
            <label>
                <input type="checkbox" name="all"
                    checked={checkedItems.all}
                    onChange={e => checkedHandler('all')} />
                <p>{a("agreeAll")}</p>
            </label>
            <label>
                <input type="checkbox" name="check1"
                    checked={checkedItems.option1}
                    onChange={e => checkedHandler('option1')} />
                <p>{a("agreeTerms")}</p>
            </label>
            <label>
                <input type="checkbox" name="check2"
                    checked={checkedItems.option2}
                    onChange={e => checkedHandler('option2')} />
                <p>{a("agreePrivacy")}</p>
            </label>
        </div>
    )
}